import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { SanitizeHtmlPipe } from '@src/app/pipes/sanitize.pipe';
import { NgClass } from '@angular/common';

export enum ToastType {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  INFO = 'info',
}
export interface IFormFieldError {
  resource: string;
  field: string;
  message: string;
}

export interface ToasterComponentData {
  type: ToastType;
  title: string;
  content?: {
    message?: string;
    loggerCode?: string;
    errors?: IFormFieldError[];
  };
  component?: any;
  componentInputs?: any;
}

type ToasterComponent = {
  type: ToastType;
  title: string;
  content?: { message?: string };
}

@Component({
  selector: 'app-toaster-widget',
  templateUrl: './toaster-widget.component.html',
  styleUrls: ['./toaster-widget.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, MatSnackBarModule, SanitizeHtmlPipe, NgClass],
})
export class ToasterWidgetComponent {
  public imageSettings: { [key: string]: { url: string; width: string; height: string } } = {
    warning: {
      url: '/assets/images/icons/icon-attention.png',
      width: '22px',
      height: '22px',
    },
    success: {
      url: '/assets/images/icons/icon-success.png',
      width: '22px',
      height: '18px',
    },
    info: {
      url: '/assets/images/icons/icon-attention.png',
      width: '22px',
      height: '22px',
    },
    error: {
      url: '/assets/images/icons/icon-expired.png',
      width: '18px',
      height: '18px',
    },
  };

  constructor(
    private snackBarRef: MatSnackBarRef<ToasterComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: ToasterComponentData,
  ) {}

  public get classes(): string {
    return `toaster ${this.data.type}`;
  }

  public close(): void {
    this.snackBarRef.dismiss();
  }
}
